// src/pages/LoanBalanceLedger/LoanBalanceLedgerSlice.js
import { createSlice } from "@reduxjs/toolkit";
import {
  fetchLoanBalanceLedger,
  fetchLoanAccountsBySearch,
} from "./LoanBalanceLedgerThunk";

const initialState = {
  list: [],
  loading: false,
  loanAccounts: [],
  loanAccountLoading: false,
  filters: {
    accId: null,
    fromDate: null,
    toDate: null,
  },
};

const loanBalanceLedgerSlice = createSlice({
  name: "loanBalanceLedger",
  initialState,
  reducers: {
    setFilters: (state, action) => {
      state.filters = { ...state.filters, ...action.payload };
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchLoanBalanceLedger.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchLoanBalanceLedger.fulfilled, (state, action) => {
        state.loading = false;
        state.list = action.payload;
      })
      .addCase(fetchLoanBalanceLedger.rejected, (state) => {
        state.loading = false;
      })
      .addCase(fetchLoanAccountsBySearch.pending, (state) => {
        state.loanAccountLoading = true;
      })
      .addCase(fetchLoanAccountsBySearch.fulfilled, (state, action) => {
        state.loanAccountLoading = false;
        state.loanAccounts = action.payload;
      })
      .addCase(fetchLoanAccountsBySearch.rejected, (state) => {
        state.loanAccountLoading = false;
        state.loanAccounts = [];
      });
  },
});

export const { setFilters } = loanBalanceLedgerSlice.actions;
export default loanBalanceLedgerSlice.reducer;
